import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getAnalytics } from 'firebase/analytics'
import { getMessaging } from 'firebase/messaging'

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}


// Validate that all required environment variables are present
const requiredEnvVars = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID',
]

const missingEnvVars = requiredEnvVars.filter((envVar) => !import.meta.env[envVar])

if (missingEnvVars.length > 0) {
  const errorMsg = `Missing required environment variables: ${missingEnvVars.join(', ')}`
  console.error('Firebase Configuration Error:', errorMsg)

  if (import.meta.env.DEV) {
    console.warn('RUNNING IN DEVELOPMENT MODE: Firebase initialization skipped. Some features will not work until you set up your .env file.')
    // Provide a more helpful instruction
    console.warn('Please copy .env.example to .env and fill in your Firebase credentials.')
  } else {
    throw new Error(errorMsg)
  }
}

// Initialize Firebase only if we have the required config
let app
let auth
let db
let storage
let analytics
let messaging

try {
  if (missingEnvVars.length === 0) {
    app = initializeApp(firebaseConfig)
    auth = getAuth(app)
    db = getFirestore(app)
    storage = getStorage(app)
    analytics = typeof window !== 'undefined' ? getAnalytics(app) : null

    // Initialize messaging only if supported and in browser environment
    // Use try-catch specifically for messaging as it might fail in some environments (e.g., non-https, localip)
    if (typeof window !== 'undefined') {
      try {
        messaging = getMessaging(app)
      } catch (msgError) {
        console.warn('Firebase Messaging initialization failed:', msgError)
      }
    }
  }
} catch (error) {
  console.error('Error initializing Firebase:', error)
}

export { auth, db, storage, analytics, messaging }
export default app
